import { render } from "./SettingsXeroView.vue?vue&type=template&id=79477090"
import script from "./SettingsXeroView.vue?vue&type=script&lang=js"
export * from "./SettingsXeroView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__